import * as React from "react";
import {db} from "../../firebase";
import {Radio, Form, Button} from 'semantic-ui-react'
import {WithContext as ReactTags} from 'react-tag-input';
import './reactTags.css';

interface InterfaceProps {
    error?: any;
    history?: any;
    categoryName?: string;
    categoryPriority?: string;
    tags?: any[];
    relatedTags?: any[];
    onCategoryUpdated: any
    onModalClosed: any
    category: any
}

interface InterfaceState {
    error?: any;
    categoryName?: string;
    categoryPriority?: string;
    relatedTags?: any[];
}

export class CategoryUpdateForm extends React.Component<InterfaceProps,
    InterfaceState> {
    private static INITIAL_STATE = {
        error: null,
        categoryName: "",
        categoryPriority: null,
        relatedTags: [],
    };

    private static propKey(propertyName: string, value: string): object {
        return {[propertyName]: value};
    }

    constructor(props: any) {
        super(props);
        const {category} = this.props;
        this.state = {
            error: null,
            categoryName: category.name,
            categoryPriority: category.priority,
            relatedTags: category.tags
        };


        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
    }

    public onSubmit = (event: any) => {
        const {categoryName, relatedTags, categoryPriority}: any = this.state;
        const {category, onCategoryUpdated} = this.props;

        db.doUpdateCategoryWithTags(category, categoryName, relatedTags, categoryPriority)
            .then(() => {
                this.setState(() => ({...CategoryUpdateForm.INITIAL_STATE}));
                onCategoryUpdated(category.id)
            })
            .catch(error => {
                this.setState(CategoryUpdateForm.propKey("error", error));
            });
        event.preventDefault();
    };

    handleDelete(i) {

        const {relatedTags} = this.state;
        this.setState({
            relatedTags: relatedTags.filter((tag, index) => index !== i),
        });
    }

    handleAddition(tag) {

        let tags = this.state.relatedTags

        tags.push(tag)


        this.setState({relatedTags : tags});
    }

    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.relatedTags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        this.setState({relatedTags: newTags});
    }


    public render() {
        const {categoryName, relatedTags, categoryPriority, error}: any = this.state;
        const {tags, onModalClosed}: any = this.props;
        const tagOptions = Object.keys(tags).map(key => ({
            id: key,
            text: tags[key].text,
            //categories: tags[key].categories
        }));
        const isInvalid = categoryName === "";

        return (
            <Form onSubmit={event => this.onSubmit(event)}>
                <Form.Field>
                    <label>Category Name</label>
                    <input
                        value={categoryName}
                        onChange={event => this.setStateWithEvent(event, "categoryName")}
                        type="text"
                        placeholder="Category Name"
                    />
                </Form.Field>
                <Form.Group inline>
                    <label>Order : </label>
                    <Form.Field
                        control={Radio}
                        label='Top'
                        value={1}
                        checked={categoryPriority === 1}
                        onChange={(e, {value}) => this.handlePrioritychange(value)}
                    />
                    <Form.Field
                        control={Radio}
                        label='Medium'
                        value={2}
                        checked={categoryPriority === 2}
                        onChange={(e, {value}) => this.handlePrioritychange(value)}
                    />
                    <Form.Field
                        control={Radio}
                        label='Basic'
                        value={3}
                        checked={categoryPriority === 3}
                        onChange={(e, {value}) => this.handlePrioritychange(value)}
                    />
                </Form.Group>
                <Form.Field>
                    <label>Related Tags</label>
                    <div>
                        <ReactTags
                            placeholder="Add a tag"
                            tags={relatedTags}
                            suggestions={tagOptions}
                            handleDelete={this.handleDelete}
                            handleAddition={this.handleAddition}
                            handleDrag={this.handleDrag}
                        />
                    </div>
                </Form.Field>
                <Button type='submit' disabled={isInvalid} positive>Save</Button>
                <Button onClick={onModalClosed} primary>Dismiss</Button>
                {error && <p>{error.message}</p>}
            </Form>
        );
    }

    private setStateWithEvent(event: any, columnType: string): void {
        this.setState(
            CategoryUpdateForm.propKey(columnType, (event.target as any).value)
        );
    }

    private handlePrioritychange = (value: any) => this.setState({categoryPriority: value})

}



// WEBPACK FOOTER //
// ./src/pills/categories/categoryUpdateForm.tsx